import React, { Component } from 'react';
import '../styles/NavigationBar.css';


class NavigationBar extends Component {

  render () {
    return (
      <div className='NavigationBar'>
        <div className='titleContainer'>
          <img alt='recommend me fantasy books' className='titleContainerLogo' src={require('../images/title.png')}/>
          {/* <div className="fb-share-button" data-href="http://recommendmefantasybooks.com/" data-layout="button_count" data-size="small" data-mobile-iframe="true"><a target="_blank" href="https://www.facebook.com/sharer/sharer.php?u=http%3A%2F%2Frecommendmefantasybooks.com%2F&amp;src=sdkpreparse" className="fb-xfbml-parse-ignore">Share</a></div> */}
        </div>
      </div>
    )
  }
}

export default NavigationBar;



// WEBPACK FOOTER //
// ./src/components/NavigationBar.js